import { __assign, __extends } from "tslib";
import * as React from 'react';
import { HeightAnimation } from '../../animations/height/height';
import { namespacedClassnames, noop } from '../../common';
import { Text } from '../../new-libby/core/typography';
import { Icon } from '../icon/icon';
import { smallCollapsibleToggle } from '../../icons';
import { Button } from '../../new-libby/core/button';
var Collapsible = /** @class */ (function (_super) {
    __extends(Collapsible, _super);
    function Collapsible() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleCollapsible = function (e) { return _this.props.onToggle(!_this.props.isOpen, e); };
        _this.getIsOpen = function () { return _this.props.disabled ? false : _this.props.isOpen; };
        return _this;
    }
    Collapsible.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames('collapsible', props.className, { open: this.getIsOpen(), disabled: props.disabled });
        var textContent = typeof props.title === 'string' ? { html: props.title } : { children: props.title };
        var toggleIcon = React.createElement(Icon, { className: 'toggle-icon', icon: smallCollapsibleToggle });
        return (React.createElement("div", { className: classNames },
            React.createElement("div", { className: 'title-wrapper', onClick: !props.toggleOnIconOnly ? this.toggleCollapsible : noop },
                props.toggleOnIconOnly ?
                    React.createElement(Button, { type: 'tertiary', className: 'toggle-icon-wrapper', onClick: this.toggleCollapsible }, toggleIcon) :
                    toggleIcon,
                React.createElement(Text, __assign({ type: 'tm', color: 't20', className: 'title' }, textContent))),
            React.createElement("div", { className: 'content-wrapper' },
                React.createElement(HeightAnimation, { show: this.getIsOpen() },
                    React.createElement("div", { className: 'content' }, props.children)))));
    };
    return Collapsible;
}(React.PureComponent));
export { Collapsible };
//# sourceMappingURL=collapsible.js.map